import { useEffect, useRef } from "react";

function useFocusOnLoad<T extends HTMLElement>(shouldFocus: boolean = true) {
  const ref = useRef<T | null>(null);

  useEffect(() => {
    if (shouldFocus && ref.current) {
      setTimeout(() => {
        ref.current?.focus({ preventScroll: false });
        ref.current?.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 0); // Delay to allow browser's native scroll restoration to apply first
    }
  }, [shouldFocus]);

  return ref;
}

export default useFocusOnLoad;
